import orderBy from 'lodash/orderBy'

import column from './interface'

export const keys = <P extends object>(obj: P): Array<keyof P> => {
  return Object.keys(obj) as Array<keyof P>
}

export const hasKey = <P extends object>(obj: P, key: keyof any): key is keyof P => {
  return key in obj
}

export const getPropertyFromColumn = (
  row: {
    [key: string]: number | string | boolean
  },
  column: column
): any => {
  if (hasKey(row, column.field)) {
    return row[column.field]
  }
  return null
}

export const getSortDirection = (direction: boolean): 'asc' | 'desc' => (direction ? 'asc' : 'desc')

export const toggleSortDirection = (direction: 'asc' | 'desc' | 'none'): 'asc' | 'desc' | 'none' => {
  switch (direction) {
    case 'asc':
      return 'desc'
    case 'desc':
      return 'none'
    default:
      return 'asc'
  }
}

export const sort = (
  rows: {}[],
  field = '',
  direction: 'asc' | 'desc' | 'none',
  defaultSortField: string,
  defaultSortDirection: 'asc' | 'desc',
  sortFn?: Function
) => {
  const sortField = field === 'dateStr' ? 'dateAsNumberForSorting' : field

  let defaultRows = orderBy(rows, [defaultSortField], [defaultSortDirection])

  if (direction === 'none') {
    return defaultRows
  }

  if (sortFn && typeof sortFn === 'function') {
    return sortFn(defaultRows, [sortField], [direction])
  }

  return orderBy(defaultRows, [sortField], [direction])
}

export const multiSort = (
  rows: {}[],
  fields = [''],
  directions: ('asc' | 'desc' | 'none')[],
  defaultSortField: string,
  defaultSortDirection: 'asc' | 'desc'
) => {
  let filteredFields = []
  let filteredDirections = []

  directions.forEach((direction, idx) => {
    if (direction !== 'none') {
      filteredDirections.push(direction)
      filteredFields.push(fields[idx])
    }
  })

  let defaultRows = orderBy(rows, defaultSortField, defaultSortDirection)

  if (filteredFields.length === 0) {
    return defaultRows
  }

  return orderBy(defaultRows, filteredFields, filteredDirections)
}

export const getNumberOfPages = (rowCount: number, rowsPerPage: number) => Math.ceil(rowCount / rowsPerPage)

export const recalculatePage = (prevPage: number, nextPage: number) => Math.min(prevPage, nextPage)
